import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '../../../../components/spaden/icons/ArrowRight';
import ArrowLeft from '../../../../components/spaden/icons/ArrowLeft';
import classNames from 'classnames';

import {
    connectSubCompany,
    disconnectSubCompany,
} from '../../actions/subCompaniesActions';

export default class SubCompany extends Component {
    static propTypes = {
        company: PropTypes.shape({
            connected: PropTypes.bool.isRequired,
            error: PropTypes.object,
            id: PropTypes.number.isRequired,
            loading: PropTypes.bool.isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        error: PropTypes.object,
        profileId: PropTypes.number.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    onClick = () => {
        if (this.props.company.connected) {
            this.props.dispatch(
                disconnectSubCompany(
                    this.props.profileId,
                    this.props.company.id
                )
            );
        } else {
            this.props.dispatch(
                connectSubCompany(this.props.profileId, this.props.company.id)
            );
        }
    };

    renderButtonText() {
        if (this.props.company.connected) {
            return (
                <span>
                    Fjern tilknytning
                    <ArrowRight className="u-valign-middle u-ml8 u-mb4" />
                </span>
            );
        } else {
            return (
                <span>
                    <ArrowLeft className="u-valign-middle u-mr8 u-mb4" />
                    Opprett tilknytning
                </span>
            );
        }
    }

    renderButton() {
        const className = classNames('button button--flat u-ml4', {
            'button--in-progress': this.props.company.loading,
        });

        return (
            <button className={className} onClick={this.onClick}>
                {this.renderButtonText(this.props.company)}
            </button>
        );
    }

    renderError() {
        if (this.props.company.error) {
            return (
                <span className="u-cherry">
                    Usjda! Vi klarte ikke å{' '}
                    {this.props.company.connected ? 'fjerne' : 'opprette'}{' '}
                    tilknytningen. Prøv igjen
                </span>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <li>
                <span className="t4">{this.props.company.title}</span>
                {this.renderButton()}
                {this.renderError()}
            </li>
        );
    }
}
